import { render, staticRenderFns } from "./ImageItem1Template.vue?vue&type=template&id=10ddd14e"
import script from "./ImageItem1Template.vue?vue&type=script&lang=js"
export * from "./ImageItem1Template.vue?vue&type=script&lang=js"
import style0 from "./ImageItem1Template.vue?vue&type=style&index=0&id=10ddd14e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports